module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/fv_btn_bac979cfcf0a57362dde47d153f2bc9e.png";